if (typeof Promise === 'undefined') {
    // Rejection tracking prevents a common issue where React gets into an
    // inconsistent state due to an error, but it gets swallowed by a Promise,
    // and the user has no idea what causes React's erratic future behavior.
    // eslint-disable-next-line global-require, import/no-extraneous-dependencies
    require('promise/lib/rejection-tracking').enable();
    // eslint-disable-next-line no-undef, global-require, import/no-extraneous-dependencies
    window.Promise = require('promise/lib/es6-extensions.js');
}

// URLSearchParams polyfill
require('url-search-params-polyfill');

// Lots of ES6/ES7 polyfills for IE compatibility
require('core-js/es6/symbol');
require('core-js/es6/number');
require('core-js/es6/string');
require('core-js/es6/array');
require('core-js/es7/array');
require('core-js/es6/object');

// fetch() polyfill for making API calls.
// eslint-disable-next-line import/no-extraneous-dependencies
require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
// eslint-disable-next-line import/no-extraneous-dependencies
Object.assign = require('object-assign');

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
    // eslint-disable-next-line global-require, import/no-extraneous-dependencies
    require('raf').polyfill(global);

    // eslint-disable-next-line global-require, import/no-extraneous-dependencies
    const enzyme = require('enzyme');
    // eslint-disable-next-line global-require, import/no-extraneous-dependencies
    const Adapter = require('enzyme-adapter-react-16');

    enzyme.configure({ adapter: new Adapter() });
}


/* eslint-disable no-undef */
function CustomEvent(event, params) {
    // eslint-disable-next-line no-param-reassign
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
}
CustomEvent.prototype = window.Event.prototype;

if (typeof window.CustomEvent !== 'function') {
    window.CustomEvent = CustomEvent;
}
/* eslint-enable no-undef */



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 130
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15